"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var saveToDisk_1 = require("../../helpers/saveToDisk");
var dcCalendarFilterController = /** @class */ (function () {
    function dcCalendarFilterController($rootScope, UserService, DrivesFilterService, CalendarModel, DrivesModel, CalendarService, FlashService) {
        this.$rootScope = $rootScope;
        this.currentUser = UserService.getCurrentUser();
        this.filterOptions = DrivesFilterService.getFilterOptions();
        this.applyingFilter = false;
        this.submittingDownload = false;
        this.FlashService = FlashService;
        this.UserService = UserService;
        this.DrivesFilterService = DrivesFilterService;
        this.CalendarModel = CalendarModel;
        this.CalendarService = CalendarService;
        this.showDriveSessionFilters = this.showDriveSessionFilters.bind(this);
        this.setFilterStatus = this.setFilterStatus.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.submitDownload = this.submitDownload.bind(this);
        this.applyFilterData = this.applyFilterData.bind(this);
        this.prepareFilterQuery = this.prepareFilterQuery.bind(this);
        this.getFilterMethod = this.getFilterMethod.bind(this);
        this.applyFilterDataToAgenda = this.applyFilterDataToAgenda.bind(this);
        this.applyFilterDataToCalendar = this.applyFilterDataToCalendar.bind(this);
        this.filter = DrivesFilterService.getFilterParameters();
    }
    dcCalendarFilterController.prototype.showDriveSessionFilters = function () {
        if (this.filter.hasOwnProperty("service") &&
            typeof this.filter.service !== "undefined" &&
            this.filter.service.name !== "undefined") {
            return this.filter.service.isDriveSession;
        }
    };
    dcCalendarFilterController.prototype.applyFilterDataToAgenda = function (response) {
        this.CalendarService.setAgendaItems(this.CalendarService.processAgenda(response));
        this.$rootScope.$broadcast("UPDATE_AGENDA");
        this.applyingFilter = false;
    };
    dcCalendarFilterController.prototype.applyFilterDataToCalendar = function (response) {
        this.CalendarModel.setAgenda(response);
        var entities = this.CalendarService.processCalendar(response);
        this.CalendarService.setCalendarItems(entities);
        this.$rootScope.$broadcast("UPDATE_CALENDAR");
        this.applyingFilter = false;
        this.CalendarService.enableFullCalendarControls();
    };
    dcCalendarFilterController.prototype.applyFilterData = function (response) {
        if (this.context === "agenda" || this.context === "student") {
            this.applyFilterDataToAgenda(response);
        }
        if (this.context === "calendar") {
            this.applyFilterDataToCalendar(response);
        }
    };
    dcCalendarFilterController.prototype.prepareFilterQuery = function () {
        var filterQuery = {
            start_date: this.DrivesFilterService.getStartDate(),
            end_date: this.DrivesFilterService.getEndDate(),
            date: this.DrivesFilterService.getDate(),
            service: this.filter.service,
            location: this.filter.location,
            instructor: this.filter.instructor,
            vehicle: this.filter.vehicle,
            status: this.filter.status,
            statusIsnt: "Inactive - Scheduling Conflict",
            days: this.filterOptions.days, // for student calendar
            times: this.filterOptions.times, // for student calendar
        };
        this.DrivesFilterService.setFilterParameters(filterQuery);
        return filterQuery;
    };
    dcCalendarFilterController.prototype.getFilterMethod = function () {
        var filterQuery = this.prepareFilterQuery();
        if (this.context === "calendar") {
            return this.CalendarModel.filterAdminCalendar(filterQuery);
        }
        if (this.context === "agenda") {
            return this.CalendarModel.getAdminAgenda(filterQuery);
        }
        if (this.currentUser.role.type === "student" ||
            this.context === "student") {
            return this.CalendarModel.getStudentCalendar(filterQuery);
        }
    };
    /**
     * Update the calendar when the filters are changed
     */
    dcCalendarFilterController.prototype.applyFilter = function () {
        var _this = this;
        this.applyingFilter = true;
        this.CalendarService.disableFullCalendarControls();
        this.CalendarService.clearItems();
        this.getFilterMethod()
            .then(this.applyFilterData)
            .catch(function (Error) {
            _this.applyingFilter = false;
        });
    };
    dcCalendarFilterController.prototype.submitDownload = function () {
        var _this = this;
        this.submittingDownload = true;
        var filterQuery = this.prepareFilterQuery();
        this.CalendarModel.downloadAdminCalendar(filterQuery)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            (0, saveToDisk_1.saveToDisk)(response.url, response.filename);
            _this.submittingDownload = false;
        })
            .catch(function (Error) {
            _this.submittingDownload = false;
        });
    };
    dcCalendarFilterController.prototype.setFilterStatus = function (status) {
        this.activeTab = status;
        this.filter.status = status;
    };
    return dcCalendarFilterController;
}());
dcCalendarFilterController.$inject = [
    "$rootScope",
    "UserService",
    "DrivesFilterService",
    "CalendarModel",
    "DrivesModel",
    "CalendarService",
    "FlashService",
];
exports.default = dcCalendarFilterController;
